<template>
  <div class="yhc-component YhcTextarea" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>

    <div class="content">
      <el-input
        :rows="rows"
        type="textarea"
        @input="$_change"
        class="el-component-item"
        :disabled="onlyRead"
        clearable
        v-model="result"
        :placeholder="placeholder ? placeholder : `请输入${label}`"
      ></el-input>
    </div>
    <PrivateEndLabel
      v-if="endLabel"
      :isBtnEndLabel="isBtnEndLabel"
      :endLabelType="endLabelType"
      :endLabelStyle="endLabelStyle"
      :endLabel="endLabel"
      @tapEndLabel="$_tapEndLabel"
    ></PrivateEndLabel>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';
import methodsMixin3 from './componentsData/methodsMixin3';
import watchMixin from './componentsData/watchMixin';
import mountedMixin from './componentsData/mountedMixin';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

let identifierName = 'YhcTextarea';

export default {
  name: identifierName,

  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin, methodsMixin, methodsMixin3, watchMixin, mountedMixin],

  data() {
    return {
      result: this.value,
    };
  },

  props: {
    rows: {
      type: Number,
      default: 5,
    },
    value: {
      type: [String, Boolean, Number],
    },
    onlyReadShowData: {
      type: [Number, String],
    },
  },

  computed: {},
  watch: {},
  methods: {},
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcTextarea {
  @include labelCommon();
}
</style>
